import { render } from "./LessonLayout.vue?vue&type=template&id=68d08b0b&scoped=true"
import script from "./LessonLayout.vue?vue&type=script&lang=js"
export * from "./LessonLayout.vue?vue&type=script&lang=js"

import "./LessonLayout.vue?vue&type=style&index=0&id=68d08b0b&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d08b0b"]])

export default __exports__